import { render } from "./invitado_evento.vue?vue&type=template&id=4b609075&scoped=true"
import script from "./invitado_evento.vue?vue&type=script&lang=js"
export * from "./invitado_evento.vue?vue&type=script&lang=js"

import "./invitado_evento.vue?vue&type=style&index=0&id=4b609075&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b609075"]])

export default __exports__